import * as React from 'react';

import { DropdownFilter, PriceDropdown } from '../../../../components/Filters';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../../types/redux';
import { changeSavedFilters } from '../../../../actions/filters';
import { getPriceLabel } from './utils/getPriceLabel';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback';
import { DELAY } from '../../constants';
import { selectPriceFilters } from '../../../../selectors/filters';
import { useDropdownFilter } from '../../hooks/useDropdownFilter';

export const PriceContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const { priceFrom, priceTo } = useSelector(selectPriceFilters, shallowEqual);

  const { filterRef, tooltipOpened, isOpen, onClick, onClose } = useDropdownFilter('price');

  const handlePriceFromChange = useDebouncedCallback(
    (value?: number) => {
      dispatch(changeSavedFilters({ priceFrom: value }, 'price'));
    },
    DELAY,
    [],
  );

  const handlePriceToChange = useDebouncedCallback(
    (value?: number) => {
      dispatch(changeSavedFilters({ priceTo: value }, 'price'));
    },
    DELAY,
    [],
  );

  const label = React.useMemo(() => getPriceLabel(priceFrom, priceTo) || 'Цена', [priceFrom, priceTo]);

  return (
    <div ref={filterRef}>
      <DropdownFilter
        open={isOpen}
        label={label}
        openTooltip={tooltipOpened}
        onClose={onClose}
        onClick={onClick}
        dataName="Price"
        dropdownContent={
          <PriceDropdown
            priceFrom={priceFrom}
            priceTo={priceTo}
            onPriceFromChange={handlePriceFromChange}
            onPriceToChange={handlePriceToChange}
            tooltipOpened={tooltipOpened}
            filterRef={filterRef}
            onClose={onClose}
          />
        }
      />
    </div>
  );
};
